var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"drawCode"},[_c('div',{staticClass:"left"},[_c('img',{attrs:{"src":_vm.imgurl}})]),_c('div',{staticClass:"right"},[_c('i',{staticClass:"el-icon-refresh-right",on:{"click":_vm.toCode}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }